/** DOM event when tenant staff should refresh incoming orders. */
export const TENANT_ORDERS_UPDATED_EVENT = 'catalogofworks:tenant-orders-updated';

export type TenantOrdersUpdatedDetail = {
  orderId?: string;
  status?: string;
};

export function dispatchTenantOrdersUpdated(detail: TenantOrdersUpdatedDetail = {}): void {
  window.dispatchEvent(new CustomEvent(TENANT_ORDERS_UPDATED_EVENT, { detail }));
}
